export { useDrawerBody_unstable as useDrawerBody } from '@fluentui/react-drawer';
